// extracted by mini-css-extract-plugin
module.exports = {"itemHolder":"InRoomSkinnableItem_itemHolder__BHgDl","uploadIcon":"InRoomSkinnableItem_uploadIcon__o6Vla"};